export { catchPromiseError } from '@/utils/errorHandle'
/**
 * 不处理的狀態碼
 * @param {String || Array} codeLv1：一级狀態碼，200、404、302等
 * @param {String || Array} codeLv2：二级狀態碼，9001、6004等
 */
// export function unHandleCode(codeLv1, codeLv2) {
//   return {
//     unHandleCodeLv1: codeLv1,
//     unHandleCodeLv2: codeLv2
//   }
// }

export function unHandleCode (...unHandleCodes) {
  return unHandleCodes
}

// export const catchPromiseError = catchPromiseError
